import React, { Component, useEffect } from 'react';
import { Router, Route } from 'react-router-dom';

import TaskListContainer from 'tasks/containers/TaskListContainer';
import StockListContainer from './stock/containers/StockListContainer';
import ReacondicionadosContainer from './reacondicionados/containers/ReacondicionadosContainer';
import PublicStockContainer from './stock/containers/PublicStockContainer';
import PublicReacContainer from './reacondicionados/containers/PublicReacContainer';
import TaskSignContainer from 'tasks/containers/TaskSignContainer';
import InvoicesContainer from 'invoices/containers/InvoicesContainer';
import SettingsContainer from './settings/containers/SettingsContainer';
import MenuLeft from './common/components/MenuLeft';
import NotesContainer from './notes/containers/NotesContainer';

import { history } from './common/services/history';

import LoginContainer from './common/containers/LoginContainer';
import PrivateRoute from './common/components/PrivateRoute';

import './App.css';
import { auth } from './common/config/Firebase';
import { connect } from 'react-redux';
import { setLoadingUserAuth, relogin, signOut } from './actions';
import ClientsListContainer from './clients/containers/ClientsListContainer';
import TicketsContainer from 'tickets/containers/TicketsContainer';
import DashboardContainer from 'dashboard/containers/DashboardContainer';
import subscribeEvents from 'dashboard/services/subscribeEvents';
import ControlTimeContainer from 'control-time/containers/ControlTimeContainer';
import ControlTimeManagementPage from 'control-time/containers/ControlTimeManagementPage';
import ClientPortal from 'client-portal/ClientPortal';

class App extends Component {

  constructor() {
    super();
    this.state = { saving: false, loadingApp: true }
  }

  componentDidMount() {
    subscribeEvents()

    this.props.setLoadingUserAuth({ flag: true })

    setTimeout(() => this.setState({ ...this.state, loadingApp: false }), 2000)

    auth.onAuthStateChanged(user => {
      const { isSign, isSigning } = this.props.userAuthInfo

      if (isSign || isSigning) {
        return
      }

      if (user) {
        this.props.relogin({ userData: user })
        return
      }

      this.props.setLoadingUserAuth({ flag: false })
    })

    document.addEventListener("keypress", (event) => {
      const buttonSave = document.querySelector("button[title='Save']")
      if (event.code === "Enter" && buttonSave && !this.state.saving) {
        buttonSave.click()
        this.setState({ ...this.state, saving: true })
        setTimeout(() => this.setState({ ...this.state, saving: false }), 1000)
      }
    })

    document.addEventListener("dblclick", (event) => {
      if (this.state.saving) {
        return
      }

      if (event.target.closest('button')) {
        return
      }

      const element = event.target.closest('tr')

      if (!element) {
        return
      }

      const button = element.querySelector("button[title='Edit']")
      button && button.click()
    })

    setTimeout(() => this.setState({ ...this.state, firstLoad: false }), 2000)
  }

  render() {
    const content = (
      <div>
        <PrivateRoute exact path="/dashboard"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={() => <DashboardContainer />}
        />
        <PrivateRoute exact path="/settings"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["user", "admin", "super"]}
          component={() => <SettingsContainer roleUser={this.props.userAuthInfo.role} />}
        />
        <PrivateRoute exact path="/notes"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={NotesContainer}
        />
        <PrivateRoute exact path="/"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={TaskListContainer}
        />
        <PrivateRoute exact path="/task-sign"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={TaskSignContainer}
        />
        <PrivateRoute exact path="/stock"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={StockListContainer}
        />
        <PrivateRoute exact path="/refurbished"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={ReacondicionadosContainer}
        />
        <Route path="/public-stock" component={PublicStockContainer} />
        <Route path="/reacondicionados" component={PublicReacContainer} />
        <PrivateRoute path="/clients"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={ClientsListContainer}
        />
        <PrivateRoute path="/invoices"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={InvoicesContainer}
        />
        <PrivateRoute path="/proformas"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={InvoicesContainer}
        />
        <PrivateRoute path="/tickets"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["admin", "super"]}
          component={TicketsContainer}
        />
        <PrivateRoute exact path="/control-time"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["control-time"]}
          component={() => <ControlTimeContainer />}
        />
        <PrivateRoute exact path="/control-time-management"
          userAuthInfo={this.props.userAuthInfo}
          rolesAccept={["super"]}
          component={() => <ControlTimeManagementPage />}
        />
        <Route path="/login" component={(LoginContainer)} />
      </div>
    );

    return (
      <div className="App">
        <Router history={history}>
          <Route path="/portal" component={ClientPortal} />
          <Route render={({ location }) =>
            location.pathname.startsWith('/portal') ? null : (
              <MenuLeft
                isSign={this.props.userAuthInfo.isSign}
                signOut={this.props.signOut}
                roleUser={this.props.userAuthInfo.role}
                displayName={this.props.userAuthInfo.displayName}
                permissions={this.props.userAuthInfo.permissions}
                content={content}
              />
            )
          } />
        </Router>
        {this.state.loadingApp &&
          <div className="loading"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'grey',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999
            }}>
            Cargando...
          </div>}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  userAuthInfo: state.user
})

const mapDispatchToProps = dispatch => ({
  relogin: payload => dispatch(relogin(payload)),
  setLoadingUserAuth: payload => dispatch(setLoadingUserAuth(payload)),
  signOut: payload => dispatch(signOut(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(App);
